module.exports = __webpack_public_path__ + "img/security.9fd407ee.svg";